import React, { useContext } from 'react';
import { AuthAction, AuthState } from './authReducer';

export type AuthContext = {
  state: AuthState;
  dispatch: React.Dispatch<AuthAction>;
};

export const AuthContext = React.createContext<AuthContext | null>(null);

export const useAuthContext: () => [
  AuthState,
  React.Dispatch<AuthAction>,
] = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('Context not found' + AuthContext);
  }
  return [context.state, context.dispatch];
};

export const useAuth: () => AuthState = () => {
  const [state] = useAuthContext();
  return state;
};
